export class EventEmitter<T> {
    private listeners: Array<(data: T) => void> = [];

    add(listener: (data: T) => void) {
        this.listeners.push(listener);
    }

    remove(listener: (data: T) => void) {
        this.listeners = this.listeners.filter((l) => l !== listener);
    }

    emit(data: T) {
        this.listeners.forEach((listener) => listener(data));
    }

    clear() {
        this.listeners.length = 0;
    }
}
